module.exports = __webpack_public_path__ + "img/p65-jinyun-2017.fe3c2b9f.jpg";